// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnrichedTransactionTransactionError
 */
export interface EnrichedTransactionTransactionError {
}

/**
 * Check if a given object implements the EnrichedTransactionTransactionError interface.
 */
export function instanceOfEnrichedTransactionTransactionError(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EnrichedTransactionTransactionErrorFromJSON(json: any): EnrichedTransactionTransactionError {
    return EnrichedTransactionTransactionErrorFromJSONTyped(json, false);
}

export function EnrichedTransactionTransactionErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrichedTransactionTransactionError {
    return json;
}

export function EnrichedTransactionTransactionErrorToJSON(value?: EnrichedTransactionTransactionError | null): any {
    return value;
}

